"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRedemptionBannerShowAnimation = exports.clearCheckoutStorage = exports.getAlgoliaAnalyticsStorage = exports.getCustomerDeleteStorage = exports.getCustomerWelcomeFlyoutVisibilityStorage = exports.getCustomerEmailStorage = exports.getSearchHistoryStorage = exports.getRedemptionEntryHideInfoBannerFlagStorage = exports.getLastTouchpointValueStorage = exports.getLastSeenProductIdsStorage = exports.getWishlistStorage = exports.getPersonalInfoStorage = exports.getPaypalOrderIdStorage = exports.getEvelinOrderIdStorage = void 0;
var algolia_analytics_storage_1 = require("./services/algolia-analytics-storage");
var cookie_storage_item_1 = require("./services/cookie-storage-item");
var json_storage_item_1 = require("./services/json-storage-item");
var browser_storage_item_1 = require("./services/browser-storage-item");
var last_seen_products_1 = require("./services/last-seen-products");
var wishlist_storage_1 = require("./services/wishlist-storage");
__exportStar(require("./types/algolia-analytics"), exports);
__exportStar(require("./types/enum/algolia-analytics-data-source"), exports);
var getEvelinOrderIdStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.evelinOrderId', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getEvelinOrderIdStorage = getEvelinOrderIdStorage;
var getPaypalOrderIdStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.paypalOrderId', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getPaypalOrderIdStorage = getPaypalOrderIdStorage;
var getPersonalInfoStorage = function () {
    var twoHoursInSeconds = 120 * 60;
    return new json_storage_item_1.JsonStorageItem(new cookie_storage_item_1.CookieStorageItem('evelin.personalInformation', twoHoursInSeconds));
};
exports.getPersonalInfoStorage = getPersonalInfoStorage;
var getWishlistStorage = function () { return new wishlist_storage_1.WishlistStorage(); };
exports.getWishlistStorage = getWishlistStorage;
var getLastSeenProductIdsStorage = function () {
    return new last_seen_products_1.LastSeenProductIdsStorage();
};
exports.getLastSeenProductIdsStorage = getLastSeenProductIdsStorage;
var getLastTouchpointValueStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.lastTouchpointValue', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getLastTouchpointValueStorage = getLastTouchpointValueStorage;
var getRedemptionEntryHideInfoBannerFlagStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.redemptionEntry.hideInfoBanner', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getRedemptionEntryHideInfoBannerFlagStorage = getRedemptionEntryHideInfoBannerFlagStorage;
var getSearchHistoryStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.search.history', browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getSearchHistoryStorage = getSearchHistoryStorage;
var getCustomerEmailStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.customer.email', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getCustomerEmailStorage = getCustomerEmailStorage;
var getCustomerWelcomeFlyoutVisibilityStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.customer.welcomeFlyoutEnabled', browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getCustomerWelcomeFlyoutVisibilityStorage = getCustomerWelcomeFlyoutVisibilityStorage;
var getCustomerDeleteStorage = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.customer.deleteNotificationEnabled', browser_storage_item_1.StorageType.LOCAL_STORAGE);
};
exports.getCustomerDeleteStorage = getCustomerDeleteStorage;
var getAlgoliaAnalyticsStorage = function () {
    return new algolia_analytics_storage_1.AlgoliaAnalyticsStorage();
};
exports.getAlgoliaAnalyticsStorage = getAlgoliaAnalyticsStorage;
function clearCheckoutStorage() {
    (0, exports.getEvelinOrderIdStorage)().remove();
    (0, exports.getPaypalOrderIdStorage)().remove();
    (0, exports.getPersonalInfoStorage)().remove();
}
exports.clearCheckoutStorage = clearCheckoutStorage;
var getRedemptionBannerShowAnimation = function () {
    return new browser_storage_item_1.BrowserStorageItem('evelin.RedemptionBanner.showAnimation', browser_storage_item_1.StorageType.SESSION_STORAGE);
};
exports.getRedemptionBannerShowAnimation = getRedemptionBannerShowAnimation;
//# sourceMappingURL=index.js.map